import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=7a3fd8b5&"
import script from "./language-selector.vue?vue&type=script&lang=js&"
export * from "./language-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports